import styled from '@emotion/styled'
import { css } from '@emotion/react'

export type TRpIconColorVariant = 'default' | 'gold1' | 'gold3' | 'green'

export interface IconWrapperProps {
  size?: string
  colorVariant?: TRpIconColorVariant
  opacity?: number
  className?: string
}

export const IconWrapper = styled.span<IconWrapperProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: ${({ size }) => size || '10px'};

  color: ${({ colorVariant = 'default' }) => {
    switch (colorVariant) {
      case 'gold1':
        return '#FFC445'
      case 'gold3':
        return '#B29B6A'
      case 'green':
        return '#8BE589'
      case 'default':
      default:
        return '#fff'
    }
  }};

  & > svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
    opacity: ${({ opacity }) => opacity || 1};
  }
`

export const topBarIconHoverStyles = css`
  opacity: 0.5;
  transition: opacity 0.2s;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`
